import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ConnectionService } from '@services/connection-service/index';
import { EventLoggerService } from '@services/event-logger-service';
import { AppConfig } from '../../app.config';

@Component({
  selector: 'isotretinoin-consent-form',
  templateUrl: './isotretinoin-consent-form.html',
  standalone: false,
})

export class IsotretinoinConsentForm implements OnInit {
    user: Table.User;
    userLanguage: string;
    consentPresent: boolean;
    consentGivenType: 'yes' | 'no' | null = null;
    showAlreadyRespondedPopup: boolean = false;

    constructor(
        public appConfig: AppConfig,
        public conn: ConnectionService,
        public eventLogger: EventLoggerService,
        private location: Location) {
    }

  async ngOnInit(): Promise<any> {
    this.user = this.conn.getActingUser();
    this.userLanguage = this.user.get('languagePreference');
    this.eventLogger.trackEvent('ISOTRETINOIN_CONSENT_FORM_OPEN', { userId: this.user.id });
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'isotretinoin-consent-form' }));
    await this.checkIfConsentIsGivenAlready();
  }

  async checkIfConsentIsGivenAlready(): Promise<void> {
    const userChatCache = await this.conn.findUserChatCache();
    const labels: string[] = userChatCache.get('label') || [];

    if (labels.includes(this.appConfig.Shared.ISOTRETINOIN_CONSENT.ISOTRETINOIN_CONSENT_GIVEN)) {
      this.consentPresent = true;
      this.consentGivenType = 'yes';
    } else if (labels.includes(this.appConfig.Shared.ISOTRETINOIN_CONSENT.ISOTRETINOIN_CONSENT_NOT_GIVEN)) {
      this.consentPresent = true;
      this.consentGivenType = 'no';
    } else {
      this.consentPresent = false;
      this.consentGivenType = null;
    }
  }

  goBack(): void {
    this.location.back();
  }

  onConsentClick(isConsentGiven: boolean): void {
    if (this.consentPresent) {
      this.showAlreadyRespondedPopup = true;
      return;
    }
    this.handleConsent(isConsentGiven);
  }

  closePopup(): void {
    this.showAlreadyRespondedPopup = false;
  }

  async handleConsent(isConsentGiven: boolean): Promise<void> {
    this.consentGivenType = isConsentGiven ? 'yes' : 'no';
    this.consentPresent = true;
    this.eventLogger.trackEvent('ISOTRETINOIN_CONSENT_GIVEN', { userId: this.user.id, isConsentGiven: isConsentGiven ? 'YES' : 'NO' });
    this.conn.navigateToURL('/user?tab=home', false, true);
  }
}
